
import { Vue, Component, Prop } from "vue-property-decorator";
import InformationCard from "@/components/inforationCards/InformationCard.vue";
import InformationSection from "@/components/inforationCards/InformationSection.vue";
import InformationWrapper from "@/components/inforationCards/InformationWrapper.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
import RouteNames from "@/entities/RouteNames";
import ItemChip from "@/components/common/ItemChip.vue";
import EmployeeRemovedFromCompanyTooltip from "@/components/tooltip/EmployeeRemovedFromCompanyTooltip.vue";


interface ItemChipsData {
  id: string;
  name: string;
  role?: string;
}

@Component({
  components: {
    EmployeeRemovedFromCompanyTooltip,
    ItemChip,
    InformationWrapper,
    InformationCard,
    InformationSection,
    LoadingOverlay,
    ItemChipsWithMore,
  },
})

export default class GroupDetails extends Vue {
  @Prop({type: Array, default: () => []}) readonly contractors!: ItemChipsData[];
  @Prop({type: Array, default: () => []}) readonly managers!: ItemChipsData[];
  @Prop({type: Array, default: () => []}) readonly skills!: ItemChipsData[];
  @Prop({type: Array, default: () => []}) readonly projects!: ItemChipsData[];
  @Prop({type: Array, default: () => []}) readonly postings!: ItemChipsData[];

  get contractorRoute(): String {
    return RouteNames.CONTRACTOR_DETAILS_ABOUT;
  }
  get managerRoute(): String {
    return RouteNames.MANAGER_ABOUT;
  }
  get projectRoute(): String {
    return RouteNames.PROJECT_ACTIVITY;
  }
  get postingRoute(): String {
    return RouteNames.RECRUITING_POSTING;
  }
}
